
export const releaseVideo = (video: HTMLVideoElement|undefined) => {
  if (!video) return
  video.pause()
  if (video.src) video.src = ''
  if (video.srcObject) video.srcObject = null
  video.load()
}
